import { render, staticRenderFns } from "./NsSearchbarList.vue?vue&type=template&id=59e1a1f6&scoped=true&"
import script from "./NsSearchbarList.vue?vue&type=script&lang=js&"
export * from "./NsSearchbarList.vue?vue&type=script&lang=js&"
import style0 from "./NsSearchbarList.vue?vue&type=style&index=0&id=59e1a1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1a1f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e1a1f6')) {
      api.createRecord('59e1a1f6', component.options)
    } else {
      api.reload('59e1a1f6', component.options)
    }
    module.hot.accept("./NsSearchbarList.vue?vue&type=template&id=59e1a1f6&scoped=true&", function () {
      api.rerender('59e1a1f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsSearchbarList.vue"
export default component.exports